import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getSessionId } from "../lib/api";
import { NfcPageView } from "../components/PagePreview";
import Seo from "../components/Seo";

const BASE = process.env.REACT_APP_BACKEND_URL;

// Page publique NFC — mobile-first, aucun compte requis, chargement minimal.
export default function PublicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [state, setState] = useState("loading"); // loading | ok | disabled | notfound

  useEffect(() => {
    let cancelled = false;
    fetch(`${BASE}/api/public/p/${slug}`)
      .then(async (res) => {
        if (cancelled) return;
        if (res.status === 404) return setState("notfound");
        const data = await res.json();
        if (!data.enabled) return setState("disabled");
        setPage(data);
        setState("ok");
        fetch(`${BASE}/api/public/p/${slug}/event`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ type: "view", sess: getSessionId() }),
        }).catch(() => {});
      })
      .catch(() => !cancelled && setState("notfound"));
    return () => {
      cancelled = true;
    };
  }, [slug]);

  const handleClick = (b) => {
    fetch(`${BASE}/api/public/p/${slug}/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type: "click", button: b.key, sess: getSessionId() }),
    }).catch(() => {});
    if (b.key === "vcard") {
      window.location.href = `${BASE}/api/public/p/${slug}/vcard`;
    } else {
      window.location.href = b.url;
    }
  };

  return (
    <div className="min-h-screen bg-nuit-950">
      <Seo
        title={page ? page.business_name : "Carte digitale"}
        description={page?.description || "Page digitale Noveocard."}
        path={`/p/${slug}`}
      />
      {state === "loading" && (
        <div className="flex min-h-screen items-center justify-center">
          <span className="h-8 w-8 animate-spin rounded-full border-2 border-electric border-t-transparent" aria-label="Chargement" />
        </div>
      )}
      {state === "ok" && page && <NfcPageView page={page} onButtonClick={handleClick} />}
      {state === "disabled" && (
        <Message title="Page momentanément indisponible" text="Cette carte digitale est temporairement désactivée. Réessayez plus tard ou contactez directement l'établissement." testid="nfc-disabled" />
      )}
      {state === "notfound" && (
        <Message title="Carte introuvable" text="Cette adresse ne correspond à aucune carte Noveocard active. Vérifiez la carte ou contactez Noveocard." testid="nfc-notfound" />
      )}
    </div>
  );
}

function Message({ title, text, testid }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center text-white" data-testid={testid}>
      <img src="/assets/logo-white.png" alt="Noveocard" className="h-7 w-auto opacity-80" width="169" height="24" />
      <h1 className="mt-8 font-display text-2xl font-bold">{title}</h1>
      <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/60">{text}</p>
      <a href="/" className="mt-8 rounded-full bg-electric px-6 py-3 font-display text-sm font-semibold text-white">
        Découvrir Noveocard
      </a>
    </div>
  );
}
